import React, { useState, useEffect } from "react";
import "./Home.css";

const images = [
  "Uzhavan-image.jpg",
  "Uzhavan-image.jpg",
  "Uzhavan-image.jpg"
];

const Home = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  // Slider auto-change
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % images.length);
    }, 5000); // change every 5 seconds
    return () => clearInterval(interval);
  }, []);

  // Booking form submit handler
  const handleSubmit = (e) => {
    e.preventDefault();

    const name = e.target.name.value;
    const from = e.target.from.value;
    const to = e.target.to.value;
    const mobile = e.target.mobile.value;
    const date = e.target.date.value;
    const time = e.target.time.value;

    const message = `Booking Details:
Name: ${name}
From: ${from}
To: ${to}
Mobile: ${mobile}
Date: ${date}
Time: ${time}`;

    const encodedMessage = encodeURIComponent(message);

    // Open WhatsApp chat with your number
    window.open(`https://wa.me/919585306000?text=${encodedMessage}`, "_blank");
  };

  return (
    <div className="slider-container" id="home">
      <img src={images[currentIndex]} alt="taxi" className="slider-image" />
      <div className="booking-form">
        <h2 >Book Your Ride</h2>
        <form onSubmit={handleSubmit}>
          <input name="name" type="text" placeholder="Name" required />
          <input name="from" type="text" placeholder="From" required />
          <input name="to" type="text" placeholder="To" required />
          <input name="mobile" type="tel" placeholder="Mobile Number" required />
          <input name="date" type="date" required />
          <input name="time" type="time" required />
          <button type="submit">Book Now</button>
        </form>
      </div>
    </div>
  );
};

export default Home;
